import React from "react";
import styles from "./RecognizedGlobally.module.css";
import { AWARDS } from "../assets";
import { fluidPx } from "../fluid";

function AwardLogo({ award }) {
  return (
    <img
      src={award.logo}
      alt={award.alt}
      className={styles.logo}
      loading="lazy"
      style={{
        width: award.logoWidth ? fluidPx(award.logoWidth) : undefined,
        height: award.logoHeight ? fluidPx(award.logoHeight) : undefined,
      }}
    />
  );
}

function AwardCard({ award }) {
  // Three shapes in the design: logo beside stacked text, a centred caption
  // above the logo, or a logo on its own.
  if (award.lines) {
    return (
      <li className={styles.card}>
        <div className={styles.rowInner}>
          <AwardLogo award={award} />
          <p className={styles.text}>
            {award.lines.map((line) => (
              <span
                key={line.text}
                className={line.bold ? styles.bold : styles.light}
              >
                {line.text}
              </span>
            ))}
          </p>
        </div>
      </li>
    );
  }

  if (award.caption) {
    return (
      <li className={styles.card}>
        <p className={styles.caption}>{award.caption}</p>
        <AwardLogo award={award} />
      </li>
    );
  }

  return (
    <li className={styles.card}>
      <AwardLogo award={award} />
    </li>
  );
}

export default function RecognizedGlobally() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <h2 className={styles.title}>Recognized Globally</h2>

        <div className={styles.panel}>
          <ul className={styles.grid}>
            {AWARDS.map((award) => (
              <AwardCard key={award.id} award={award} />
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
